import { createAPI } from '../../common'

export default {
  // Dify 对话接口
  chatMessages: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0w20dibu.nfttbhft', 'post', config, vconfig),
  // 获取历史对话列表
  conversations: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0w20dpowfstbujpot', 'get', config, vconfig),
  // 获取历史会话消息
  messagesInfo: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0w20nfttbhft', 'get', config, vconfig),
  // 删除历史对话
  deleteMessage: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0w20dpowfstbujpot', 'delete', config, vconfig),
  //获取知识问答配置的欢迎语
  getWelcomeWord: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0w20qbsbnfufst', 'get', config, vconfig),
  // 获取知识问答配置的推荐
  getSuggested: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0w20nfttbhft0tvhhftufe',
      'get',
      config,
      vconfig
    )
}
